<header class="app-header">
  <div class="left-space"></div>
  <div class="logo-container" (click)="navigateToLandingPage()">
    <img src="/assets/common/images/bdheaderlogo.svg" alt="companylogo" class="company-logo" />
  </div>
  <div class="user-button-container">
    <!-- Settings Icon with Popup -->
    <button
      class="settings-button"
      cdkOverlayOrigin
      #settingsOrigin="cdkOverlayOrigin"
      (click)="toggleSettingsPopup()"
      aria-label="Settings"
      aria-haspopup="true"
      [attr.aria-expanded]="isSettingsPopupOpen"
    >
      <img
        src="/assets/common/images/settings.svg"
        alt="Settings"
        class="settings-icon"
      />
    </button>

    <!-- Settings Popup -->
    <ng-template
      cdkConnectedOverlay 
      [cdkConnectedOverlayOrigin]="settingsOrigin"
      [cdkConnectedOverlayOpen]="isSettingsPopupOpen"
      [cdkConnectedOverlayHasBackdrop]="true"
      (backdropClick)="closeSettingsPopup()"
      [cdkConnectedOverlayPositions]="currentPositions"
    >
      <div class="settings-popup-panel" role="tooltip">
        <div class="popup-content-wrapper">
          <a class="about-link" (click)="onAboutClick()" role="button" tabindex="0">
            {{ "HEADER.ABOUT" | translate }}
          </a>
        </div>
      </div>
    </ng-template>

    <!-- User Button -->
    <button
      class="user-button"
      cdkOverlayOrigin
      #userOrigin="cdkOverlayOrigin"
      (click)="toggleUserPopup()"
      aria-label="User Profile"
      aria-haspopup="true"
      [attr.aria-expanded]="isUserPopupOpen"
    >
      <img src="/assets/common/images/userprofileicon.svg" alt="user ICON" class="user-icon" />
    </button>

    <!-- User Popup -->
    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="userOrigin"
      [cdkConnectedOverlayOpen]="isUserPopupOpen"
      [cdkConnectedOverlayHasBackdrop]="true"
      (backdropClick)="closeUserPopup()"
      [cdkConnectedOverlayPositions]="userPopupPositions"
    >
      <ul class="dropdown-menu">
        <li class="user-info">
          <div class="user-name">{{ users()?.firstName }} {{ users()?.lastName }}</div>
          <div class="user-role">{{ users()?.roles }}</div>
        </li>
        <li class="divider"></li>
        <li>
          <a (click)="onSignOut()">{{ "SESSIONEND.SIGNOUT" | translate }}</a>
        </li>
      </ul>
    </ng-template>
  </div>
</header>
